/**
 * Lower-cases the legacy moment-style year and day tokens (`YYYY`, `DD`) that
 * older Iconik date settings use, so the pattern means the same in date-fns,
 * where upper-case `Y` and `D` are week-year and day-of-year.
 *
 * @see https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 */
export function normalizeDateFormat(pattern: string): string {
  return pattern.replace(/Y/g, 'y').replace(/D/g, 'd');
}
